import DOMPurify from 'dompurify';

export const sanitize = (dirty) =>
  dirty
    ? DOMPurify.sanitize(decodeURIComponent(dirty), {
        ALLOWED_TAGS: [],
        ALLOW_DATA_ATTR: false,
      })
    : dirty;

export function stripHTML(source: string) {
  return DOMPurify.sanitize(source, {
    ALLOWED_ATTR: [],
    ALLOWED_TAGS: [],
  });
}
